/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface OutreachAssistantMessageRequest {
  /**
     * @minLength 1
     * @maxLength 20000
     */
  message: string;
  is_seed?: boolean;
}
